import { useNavigate } from 'react-router-dom';
import {
  Ranking1,
  Ranking2,
  Ranking3,
  Ranking4,
  Ranking5,
  Ranking6,
  Ranking7,
  Ranking8,
  Ranking9,
  Ranking10,
  routes,
} from '../../constants';
import { useCallback } from 'react';

type Props = {
  rank?: number;
  className?: string;
  imgClassName?: string;
  disableNavigate?: boolean;
  /** Default 5 keeps existing teco girl cards unchanged. Pass 10 for Yarikano. */
  maxRank?: 5 | 10;
};

const RANKING_IMAGES = [
  undefined,
  Ranking1,
  Ranking2,
  Ranking3,
  Ranking4,
  Ranking5,
  Ranking6,
  Ranking7,
  Ranking8,
  Ranking9,
  Ranking10,
];

const RankingBadge = ({
  rank,
  className,
  imgClassName,
  disableNavigate = false,
  maxRank = 5,
}: Props) => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (disableNavigate) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      navigate(routes.RANKING);
    },
    [disableNavigate, navigate],
  );

  const src =
    rank && rank >= 1 && rank <= maxRank ? RANKING_IMAGES[rank] : null;
  if (!src) return null;

  return (
    <div
      onClick={handleClick}
      className={`absolute left-0 bottom-8 ${className}`}
    >
      <img src={src} alt="" className={`w-12 h-12 ${imgClassName}`} />
    </div>
  );
};

export default RankingBadge;
